import { createAction } from "@reduxjs/toolkit";
import { SpaceFiltersValues } from "modules/spaces/domain/space/space.types";
import { StartEndDates } from "types/dates";

const SPACE_ACTION = "space";

export const spacesActions = {
  getSpacesByProjectRequested: createAction<
    | {
        dates?: StartEndDates;
        filters?: SpaceFiltersValues;
      }
    | undefined
  >(`${SPACE_ACTION}/getSpacesByProject`),

  getSpaceFiltersByProjectRequested: createAction(
    `${SPACE_ACTION}/getSpaceFiltersByProject`,
  ),

  getSpaceFiltersByProjectIdInProgress: createAction(
    `${SPACE_ACTION}/getSpaceFiltersByProjectIdInProgress`,
  ),

  getSpaceFiltersByProjectIdDone: createAction(
    `${SPACE_ACTION}/getSpaceFiltersByProjectIdDone`,
  ),

  getSpacesByProjectInProgress: createAction(
    `${SPACE_ACTION}/getSpacesByProjectInProgress`,
  ),
  getSpacesByProjectDone: createAction(
    `${SPACE_ACTION}/getSpacesByProjectDone`,
  ),
  loadSpacesAnswersEnd: createAction(`${SPACE_ACTION}/loadSpacesAnswersEnd`),

  getSpaceByIdRequested: createAction<string>(
    `${SPACE_ACTION}/getSpaceByIdRequested`,
  ),
  getSpaceByIdInProgress: createAction(
    `${SPACE_ACTION}/getSpaceByIdInProgress`,
  ),
  getSpaceByIdDone: createAction(`${SPACE_ACTION}/getSpaceByIdDone`),
  getSpaceByIdError: createAction<unknown>(`${SPACE_ACTION}/getSpaceByIdError`),
};
